<template>
  <div class="flex">
    <div class="search-full-container w-full h-full absolute left-0 top-0" :class="{'flex': showFullSearch}" v-show="showFullSearch">
      <vx-auto-suggest
        ref="navbarSearch"
        :autoFocus="showFullSearch"
        :data="navbarSearchAndPinList"
        search_key="title"
        background-overlay
        class="w-full"
        inputClassses="w-full vs-input-no-border vs-input-no-shdow-focus"
        icon="SearchIcon"
        placeholder="Explore GrapePerks..."
        @input="hnd_search_query_update"
        @selected="selected"
        @closeSearchbar="showFullSearch = false">

        <template v-slot:group="{ group_name }">
          <p class="font-semibold text-primary">{{ group_name | title }}</p>
        </template>

        <!-- Pages Suggestion -->
        <template v-slot:pages="{ suggestion }">
          <div class="flex items-end leading-none py-1">

            <svg
              v-if="suggestion.iconPack === 'custom' && suggestion.icon === 'square'"
              class="square-icon mr-4"
              data-testid="square-logo" width="17" height="17" viewBox="0 0 48 48" role="img" aria-hidden="false" aria-label="Square Dashboard"><g fill="currentColor" fill-rule="evenodd"><path d="M38.9085938,36.3832764 C38.9085938,37.7779998 37.7772516,38.9078455 36.3840246,38.9078455 L11.5049719,38.9078455 C10.1102484,38.9078455 8.97890625,37.7779998 8.97890625,36.3832764 L8.97890625,11.5042236 C8.97890625,10.1095002 10.1102484,8.97965449 11.5049719,8.97965449 L36.3840246,8.97965449 C37.7772516,8.97965449 38.9085938,10.1095002 38.9085938,11.5042236 L38.9085938,36.3832764 Z M39.8843016,0.000748242187 L8.00319844,0.000748242187 C3.58408008,0.000748242187 0,3.58333184 0,8.0024502 L0,39.8850498 C0,44.3041682 3.58408008,47.8867518 8.00319844,47.8867518 L39.8843016,47.8867518 C44.3034199,47.8867518 47.8875,44.3041682 47.8875,39.8850498 L47.8875,8.0024502 C47.8875,3.58333184 44.3034199,0.000748242187 39.8843016,0.000748242187 L39.8843016,0.000748242187 Z"></path><path d="M28.4332031,17.9578125 L19.4542969,17.9578125 C18.6521812,17.9578125 17.9578125,18.6506848 17.9578125,19.4542969 L17.9578125,28.4332031 C17.9578125,29.2383117 18.6521812,29.9296875 19.4542969,29.9296875 L28.4332031,29.9296875 C29.2338223,29.9296875 29.9296875,29.2383117 29.9296875,28.4332031 L29.9296875,19.4542969 C29.9296875,18.6506848 29.2338223,17.9578125 28.4332031,17.9578125"></path></g>
            </svg>

            <feather-icon
              v-else
              class="mr-4"
              svgClasses="h-5 w-5"
              :icon="suggestion.icon"/>
            <span class="mt-1">{{ suggestion.title }}</span>
          </div>
        </template>

        <!-- Files Suggestion -->
        <!-- <template v-slot:files="{ suggestion }">
          <div class="flex items-center justify-between">
            <div class="flex items-center">
              <div class="img-container w-8 mr-3 flex">
                <img :src="require(`@/assets/img/vuexy/file-icons/${suggestion.file_ext}.png`)" :alt="suggestion.file_name" class="responsive">
              </div>
              <div class="leading-none mt-1">
                <p class="mb-1">{{ suggestion.file_name }}</p>
                <small>by {{ suggestion.from }}</small>
              </div>
            </div>
            <small>{{ suggestion.size }}</small>
          </div>
        </template> -->

        <!-- Contacts Suggestion -->
        <!-- <template v-slot:contacts="{ suggestion }">
          <div class="flex items-center justify-between">
            <div class="flex items-center">
              <img :src="suggestion.img" :alt="suggestion.name" class="w-8 h-8 mr-3 rounded-full">
              <div class="leading-none mt-1">
                <p>{{ suggestion.name }}</p>
                <small>{{ suggestion.email }}</small>
              </div>
            </div>
            <small>{{ suggestion.time }}</small>
          </div>
        </template> -->

        <!-- No Items Slot -->
        <template v-slot:noResult="{ group_name }">
          <div class="flex items-center">
            <feather-icon icon="InfoIcon" svgClasses="h-5 w-5" class="mr-4" />
            <span>No results found.</span>
          </div>
        </template>

      </vx-auto-suggest>

      <div class="absolute right-0 h-full z-50">
        <feather-icon
          icon="XIcon"
          class="px-4 cursor-pointer h-full close-search-icon"
          @click="showFullSearch = false" />
      </div>
    </div>
    <feather-icon icon="SearchIcon" @click="showFullSearch = true" class="cursor-pointer navbar-fuzzy-search ml-4" />

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import VxAutoSuggest from '@/components/vx-auto-suggest/VxAutoSuggest.vue';

export default {
  components: {
    VxAutoSuggest,
  },
  data() {
    return {
      showFullSearch: false,
    };
  },
  computed: {
    ...mapGetters({
      navMenuItemsByPermissionsLineal: 'navMenuItemsByPermissionsLineal',
    }),
    navbarSearchAndPinList() {
      return {
        pages: {
          key: 'title',
          data: this.navMenuItemsByPermissionsLineal,
        },
      };
    },
  },
  methods: {
    selected(item) {
      item.pages ? this.$router.push(item.pages.url).catch(() => {}) : null;
      this.showFullSearch = false;
    },
    hnd_search_query_update(query) {
      // Show overlay if any character is entered
      this.$store.commit('TOGGLE_CONTENT_OVERLAY', !!query);
    },
  },
};

</script>
